import { hbs } from 'ember-cli-htmlbars';
export default hbs("<NwIcon\n  @icon=\"icon-small-spinner\"\n  class=\"nw-spinner\"\n  aria-hidden=\"true\"\n  data-test-spinner\n  ...attributes\n/>")